import React, { useEffect, useState } from "react";
import { Button, Checkbox, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { formatDate } from "../../../utils/dateFormatter";

const ListBallastRecordbook = () => {
  const navigate = useNavigate();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);

  const SHIP_LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const ships = res?.ships || [];
          set_ship_table_list(ships);
          const firstShipId = ships[0]?.id;
          set_ship_id(firstShipId);
          if (firstShipId) {
            LIST_BALLAST_RECORD_BOOK_API(firstShipId);
          }
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    }
  };

  const LIST_BALLAST_RECORD_BOOK_API = (ship_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_id);
      post(ApiURL.listing_ballasting_records_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const reversedData = res.records?.map((item) => ({
            ...item,
            key: item.ballasting_id.toString(),
            masterReviewed: item.reviewed_by_master || false,
          }));
          setFilteredData(reversedData);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching ballast records:", error);
      set_page_loader(false);
    }
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "ballasting_id",
      align: "center",
      key: "ballasting_id",
      sorter: (a, b) => a.ballasting_id - b.ballasting_id,
      render: (ballasting_id, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {ballasting_id}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      align: "center",
      key: "date",
      render: (date, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {formatDate(date)}
        </span>
      ),
    },
    {
      title: "Code Letter",
      dataIndex: "operation_code",
      align: "center",
      key: "operation_code",
      render: (operation_code, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {operation_code}
        </span>
      ),
    },
    {
      title: "Ballasting Sign",
      dataIndex: "ballasting_sign",
      align: "center",
      key: "ballasting_sign",
      render: (ballasting_sign, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {ballasting_sign}
        </span>
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <span>Reviewed By Master</span>
          <Checkbox
            disabled
            style={{ marginLeft: 8 }}
            checked={filteredData.length > 0 && filteredData.every((item) => item.masterReviewed)}
            indeterminate={
              filteredData.some((item) => item.masterReviewed) &&
              !filteredData.every((item) => item.masterReviewed)
            }
          />
        </div>
      ),
      align: "center",
      key: "master_review",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Checkbox disabled checked={record.masterReviewed} />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
            }}
          >
            Reviewed By Master
          </span>
        </div>
      ),
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <Tooltip title="View">
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/view-ballast-record-com/${btoa(record?.ballasting_id)}`)}
            style={{ marginRight: "15px" }}
            icon={<EyeFilled />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              LIST_BALLAST_RECORD_BOOK_API(value);
            }}
          >
            {ship_table_list.map((ship) =>
              !ship.soft_delete ? (
                <Select.Option key={ship.id} value={ship.id}>
                  {ship.vessel_name}
                </Select.Option>
              ) : null
            )}
          </Select>
        </div>
      </div>

      <div className="row" style={{ padding: "10px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Ballast Record Book Information</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/audit-trail-ballast-record-com")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>

      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default ListBallastRecordbook;
